import {
	commonMoreThan_5
} from '../../dicts/filtered';

export default function randCommonWord() {
	return commonMoreThan_5[
		Math.floor(Math.random() * commonMoreThan_5.length)
	];
}



// WEBPACK FOOTER //
// ./js/components/word_field/rand_common_word.js